import React from 'react';

import styles from 'styles/admin-detail.module.scss';
import AsyncButton from 'utils/AsyncButton';
import CloseIcon from '@material-ui/icons/Close';

const BeforeSendConfirm = (props) => {
  const { isLongTermContract, carInsuranceType, closeModal, onClick, loading } = props;

  return (
    <div className={styles.root}>
      <CloseIcon
        fontSize='large'
        className={styles.closeImg}
        onClick={closeModal}
      />
      <div className={styles.title}>
        メッセージを送信します。内容に誤りはありませんか？
      </div>
      {isLongTermContract === 1 && (
        <div className={styles.alertText}>
          長期契約です。長期契約入力箇所（車両保険金額、保険料）に漏れがないか今一度確認してください。
        </div>
      )}
      {(carInsuranceType === 1 || carInsuranceType === 2) && (
        <div className={styles.alertText}>
          新価特約が付帯できる契約の場合、新価特約入力欄（保険料）の入力漏れがないか今一度確認してください。
        </div>
      )}
      <div className={styles.displayRight}>
        <AsyncButton
          className={styles.confirmButton}
          type='button'
          color='primary'
          variant='contained'
          onClick={onClick}
          loading={loading}
        >
          送信
        </AsyncButton>
      </div>
    </div>
  );
};

export default BeforeSendConfirm;
